import React from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import dayjs from "dayjs";
import { LoadingSpinner } from "../common/Loading/LoadingSpinner";

interface DatePickerModalProps {
  show: boolean;
  onHide: () => void;
  onSubmit: (values: any, formikHelpers: any) => void;
  currentDate: Date;
}

export const DatePickerModal: React.FC<DatePickerModalProps> = ({
  show,
  onHide,
  onSubmit,
  currentDate,
}) => {
  return (
    <Modal centered show={show} keyboard={false} onHide={onHide}>
      <Formik
        initialValues={{
          date: dayjs(currentDate).format("YYYY-MM-DD"),
        }}
        validationSchema={Yup.object().shape({
          date: Yup.string().required("Date is required"),
        })}
        onSubmit={onSubmit}
      >
        {({ values, errors, touched, isSubmitting, handleSubmit }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>Go to date</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group className="mb-3" controlId="validationFormik02">
                <Field
                  name="date"
                  type="date"
                  className={
                    "form-control" +
                    (errors.date && touched.date ? " is-invalid" : "")
                  }
                />
                <ErrorMessage
                  name="date"
                  component="div"
                  className="invalid-feedback"
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <div className="form-group">
                <Button
                  variant="primary"
                  disabled={isSubmitting}
                  type="submit"
                  className="me-2"
                >
                  {isSubmitting ? (
                    <LoadingSpinner text="Going..." />
                  ) : (
                    "Go to date"
                  )}
                </Button>
                <Button variant="secondary" onClick={onHide}>
                  Cancel
                </Button>
              </div>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
